$(document).ready(function(){

  /*-----------------This is for poupvideo in image-hero section----------------------------*/
  var count_val = $('.image_thubnail li').length;
  if(count_val <= 5){
    $('.image_thubnail').addClass('get_five');
  }else{
    $('.image_thubnail').removeClass('get_five');
  }
  var media_length = $('.product__media-list li').length;
  if(media_length > 1){
     $('.product__media-list').removeClass('only_one');
  }else{
    $('.product__media-list').addClass('only_one');
  }
  
  $('body').on('click','.play-button-block__inner',function(e){
    e.preventDefault();
        var videoUrl = $(this).attr('data-url');
        var popupWidth = 640;
        var popupHeight = 360;

        var video = $('<video>', {
          src: videoUrl,
          width: popupWidth,
          height: popupHeight,
          controls: true,
          autoplay: true
        });
        $('body').addClass('video-popup');
        $('.popup-wrraper').append(video);
        $('#video-popup').fadeIn();
      });

      $('#video-popup .icon-close,.poup-overlay').click(function() {
        $('#video-popup').fadeOut();
        setTimeout(function(){
           $('#video-popup').find('video').remove();
        },500);
        $('body').removeClass('video-popup');
      });

  /*-----------------This is for PDP Image slider----------------------------*/
   function isMobile() {
        return window.innerWidth <= 769;
    }
    function isDesktop() {
        return window.innerWidth >= 769;
    }
      var vartical = $('.product_media_grid_item').attr('data-vartical');  
      var slider = $('.product_media_grid_item').attr('data-slider');
     
      var is_vartical='';
        if(vartical){
          var is_vartical = true;
        }else{
          var is_vartical = false;
        }
       
        if(slider && isDesktop()){
           $('.image_thubnail').slick({
              arrows: false,
              vertical: is_vartical,
              slidesToShow: 5,
              infinite: false,
              slidesToScroll: 1,
              asNavFor: '.product__media-list',
              focusOnSelect: true,
              verticalSwiping: is_vartical
          });
          $('.product__media-list').slick({
              arrows: false,
              dots : true,
              infinite: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              asNavFor: '.image_thubnail'
             
        });
      }

      var freeScroll = $('.product_media_grid_item').hasClass('free_scroll');
     
      if(isMobile() && !freeScroll) {
        // Disable the slider if the condition is met
          $('.image_thubnail').slick({
              arrows: false,
              slidesToShow: 5,
              infinite: false,
              slidesToScroll: 1,
              asNavFor: '.product__media-list',
              focusOnSelect: true
          });
          $('.product__media-list').slick({
              arrows: false,
              dots : true,
              infinite: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              asNavFor: '.image_thubnail'
              
          });
      }

 $(window).on('resize', function(){
   var freeScroll = $('.product_media_grid_item').hasClass('free_scroll');
    var slider = $('.product_media_grid_item').attr('data-slider');
   if(isMobile() && !freeScroll) {
     console.log('mpboil');
     if(slider){
      $('.image_thubnail').slick('refresh');
      $('.product__media-list').slick('refresh');
     }else{
       $('.image_thubnail').slick({
              arrows: false,
              slidesToShow: 5,
              infinite: false,
              slidesToScroll: 1,
              asNavFor: '.product__media-list',
              focusOnSelect: true
          });
          $('.product__media-list').slick({
              arrows: false,
              dots : true,
              infinite: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              asNavFor: '.image_thubnail'
              
          });
     }
   }else if(slider && isDesktop()){
      $('.image_thubnail').slick('refresh');
      $('.product__media-list').slick('refresh');
   }else{
      $('.image_thubnail').slick('unslick');
      $('.product__media-list').slick('unslick');
   }
 
  
});

});
